import React from "react";

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import { WrapperContent, LocationSelected, Column, Desc, Title, StateSelectedTitle } from "./styles";
import HeaderPage from "../../../components/patterns/subpages/header";

function SearchResultsLocation() {

    return (
        <>
            <HeaderPage>
                <LocationSelected>
                    <Column>
                        <Icon icon={["fas", "map-marker-check"]} />

                        <Desc className="Wrapper">
                            <Title>Estado selecionado</Title>
                            <StateSelectedTitle>bahia</StateSelectedTitle>
                        </Desc>
                    </Column>
                    <Column>
                        <Icon icon={["far", "chevron-down"]} />
                    </Column>
                </LocationSelected>
            </HeaderPage>

            <WrapperContent>
                Hello
            </WrapperContent>
        </>
    )
}

export default SearchResultsLocation;